// Admin API client — /admin/helm/* (mirrors the API's helm aggregate).

import type {
  HelmOverviewResponse,
  HelmRunsResponse,
  HelmRunDetailResponse,
  HelmRefreshResponse,
  HelmActionInput,
  HelmActionResponse,
  HelmConfigResponse,
  HelmSourceConfig,
} from '@a7y/platform-health/helm';
import { client, rawJson } from './transport';

export const helmApi = {
  // HELM (A7Y-3870): Yevhen's morning card. `/admin/helm/*` on a7y-api.
  getHelmOverview: () => client.get<HelmOverviewResponse>('/helm/overview'),
  getHelmRuns: (limit = 30, days?: number) =>
    client.get<HelmRunsResponse>(`/helm/runs?limit=${limit}${days != null ? `&days=${days}` : ''}`),
  /** A7Y-3872: one past run, overlaid with actions as they stood at its
   *  `completedAt` (D14). 404/`HELM_RUN_NOT_FOUND` or 409/`HELM_RUN_NOT_VIEWABLE`
   *  surface through the shared client's non-2xx throw, same as every other
   *  route here. */
  getHelmRun: (runId: string) =>
    client.get<HelmRunDetailResponse>(`/helm/runs/${encodeURIComponent(runId)}`),
  refreshHelm: () => client.post<HelmRefreshResponse>('/helm/refresh', {}),
  createHelmAction: (input: HelmActionInput) =>
    client.post<HelmActionResponse>('/helm/actions', input),
  undoHelmAction: (actionId: string) =>
    client.post<{ ok: true }>(`/helm/actions/${encodeURIComponent(actionId)}/undo`, {}),
  getHelmConfig: () => client.get<HelmConfigResponse>('/helm/config'),
  // PUT, not the shared client's post/patch/get/delete set — same rawJson
  // helper the affiliate PUT endpoints use.
  putHelmConfig: (config: HelmSourceConfig) =>
    rawJson<HelmConfigResponse>('/helm/config', 'PUT', config),
};
